import React from "react";
import { makeStyles } from "@material-ui/core/styles";
import Container from "@material-ui/core/Container";
import CssBaseline from "@material-ui/core/CssBaseline";
import Breadcrumb from "../../components/breadcrumb";

const useStyles = makeStyles((theme) => ({
  container: {
    margin: "auto",
    maxWidth: 1170,
    paddingTop: 32,
  },
  leadTop: {
    minHeight: 90,
  },
  main: {
    height: 900,
    width: "100%",
  },
}));

export default function ProductDetail() {
  const classes = useStyles();
  return (
    <>
      <CssBaseline />
      <Container className={classes.container}>
        <div className={classes.leadTop}>
          <div className={classes.leadTop}></div>
        </div>
        <div className={classes.main}>
          <Breadcrumb />
        </div>
      </Container>
    </>
  );
}
